import { combineReducers } from 'redux';
import multireducer from 'multireducer';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as ui } from 'redux-ui';

import translations from 'shared/redux/client/reducers/translations';
import locale from 'shared/redux/client/reducers/locale';

import entities from 'widget/redux/client/reducers/entities';
import channels from 'shared/redux/client/reducers/channels';
import videos from 'shared/redux/client/reducers/videos';
import channelVideos from 'shared/redux/client/reducers/channel-videos';

import configuration from 'widget/redux/client/reducers/configuration';
import appSettings from 'widget/redux/client/reducers/app-settings';
import paginatedChannelVideos from 'widget/redux/client/reducers/paginated-channel-videos';
import currentChannelId from 'widget/redux/client/reducers/current-channel-id';
import channelInfo from 'widget/redux/client/reducers/channel-info';
import channelVideosLazyList from 'widget/redux/client/reducers/channel-videos-lazy-load';
import currentSiteUser from 'widget/redux/client/reducers/current-site-user';
import firstChannelVideoId from 'widget/redux/client/reducers/first-channel-video-id';
import biDefaultParams from 'widget/redux/client/reducers/bi-default-params';
import videoUrlsCache from 'widget/redux/client/reducers/video-urls-cache';
import experiments from 'shared/redux/client/reducers/experiments';
import { DATA_KEY as NEXT_VIDEO_KEY } from 'widget/data-components/next-channel-videos';
import { DATA_KEY as PAGINATED_VIDEOS_KEY } from 'widget/data-components/paginated-channel-videos';
import selectedVideoId from 'widget/redux/client/reducers/selected-video-id';
import videoPlaybackStatus from 'widget/redux/client/reducers/video-playback-status';
import isVideosTouched from 'widget/redux/client/reducers/is-videos-touched';

export default combineReducers({
  routing,
  ui,
  translations,
  locale,

  entities,
  channels,
  videos,
  channelVideos,
  currentChannelId,
  channelInfo,
  currentSiteUser,
  firstChannelVideoId,
  lazyVideoLists: multireducer({
    [PAGINATED_VIDEOS_KEY]: paginatedChannelVideos,
    mobileSearch: channelVideosLazyList,
    mobileWidget: channelVideosLazyList,
    mobileOverlay: channelVideosLazyList,
    [NEXT_VIDEO_KEY]: channelVideosLazyList,
  }),
  videoUrlsCache,
  selectedVideoId,
  videoPlaybackStatus,
  isVideosTouched,

  configuration,
  appSettings,
  experiments,
  biDefaultParams,
});



// WEBPACK FOOTER //
// ./src/widget/redux/root-reducer.js